import { Vue } from 'vue-property-decorator';

/**
 * A directive that performs several clicks when the directive element is clicked and holded
 */
Vue.directive('click-hold', {
    bind: (el, binding, vnode) => {
        /**
         * Function that is performed per interval
         */
        let fn: () => void;
        /**
         * Interval time
         */
        el.dataset.emitInterval = '100';

        if (typeof binding.value === 'function') {
            fn = binding.value;
        } else if ('fn' in binding.value && 'delay' in binding.value) {
            fn = binding.value.fn;
            el.dataset.emitInterval = binding.value.delay;
        } else {
            throw Error('while-click params are wrong');
        }

        /**
         * Interval id
         */
        let intervalId: NodeJS.Timeout | null;

        /**
         * Starts interval
         */
        function startInterval() {
            fn();
            intervalId = setInterval(() => fn(), Number(el.dataset.emitInterval));
        }

        /**
         * Ends interval
         */
        function endInterval() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        }

        /**
         * Add necessary event listener
         */
        el.addEventListener('mousedown', () => startInterval());
        el.addEventListener('mouseup', () => endInterval());
        el.addEventListener('mouseleave', () => endInterval());
    },
    update: (el, binding, vnode) => {
        // update emitInterval
        if (binding.value?.delay) {
            el.dataset.emitInterval = `${binding.value?.delay}`;
        }
    }
});
